<script>

export default {
    name: 'v-list',
    props: {
        items: {
            name: 'Items',
            type: Array,
            txtDescr: `[:value] Items of the list (default slot may be used instead), each item is object like {icon='', title: '', subtitle: '', iconAction: '', urlAction: '', divider: false}. Icon is placed on the left, then goes title, then subtitle (maybe on the next line), then action as button with icon and url, and then divider may be presented if true`,
            default: _ => []
        },
        itemsTitle: {
            name: 'Items (title)',
            type: Array,
            txtDescr: `[:itemsTitle]`,
            default: _ => []
        },
        itemsSubtitle: {
            name: 'Items (subtitle)',
            type: Array,
            txtDescr: `[:itemsSubtitle]`,
            default: _ => []
        },
        itemsIcon: {
            name: 'Items (icon)',
            type: Array,
            txtDescr: `[:itemsIcon]`,
            default: _ => []
        },
        itemsIconAction: {
            name: 'Items (icon action)',
            type: Array,
            txtDescr: `[:itemsIconAction]`,
            default: _ => []
        },
        itemsUrlAction: {
            name: 'Items (url action)',
            type: Array,
            txtDescr: `[:itemsUrlAction]`,
            default: _ => []
        },
        itemsDivider: {
            name: 'Items (divider)',
            type: Array,
            txtDescr: `[:itemsDivider]`,
            default: _ => []
        },
        lines: {
            name: 'Lines',
            type: Number,
            enum: [1, 2, 3],
            txtDescr: `[:lines] number of the lines for item`,
            default: _ => 1
        },
        isDense: {
            name: 'Is dense',
            type: Boolean,
            txtDescr: `[:isDense] If is true, then list will be dense`,
            default: _ => false
        },
        isPaddItem: {
            name: 'Is padding item',
            type: Boolean,
            txtDescr: `[:isPaddItem] If is true, then list items without icons will have additional padding`,
            default: _ => false
        }
    },
    computed: {
        items_() {
            return this.itemsTitle.map(([title, i]) => ({
                title,
                subtitle: this.itemsSubtitle[i],
                icon: this.itemsIcon[i],
                iconAction: this.itemsAction[i],
                urlAction: this.itemsUrlAction[i],
                divider: this.itemsDivider[i]
            }))
        }
    }
}
</script>

<template lang="pug">

div
    md-list(
        :class=`{
            'md-dense': isDense,
            'md-double-line': lines == 2,
            'md-triple-line': lines == 3
        }`)
        slot
            md-list-item(
                v-for="(item, i) of items_"
                :key="i"
                :class=`{
                    'md-inset': isPaddItem && !item.icon
                }`)
                md-icon(
                    v-if="item.icon") {{ item.icon }}
                div.md-list-text-container
                    span {{ item.title }}
                    span {{ item.subtitle }}
                md-button.md-icon-button.md-list-action(
                    v-if="item.action")
                    md-icon.md-primary chat_bubble
                md-divider(
                    :class=`{
                        'md-inset': isPaddItem && !item.icon
                    }`)
</template>



// WEBPACK FOOTER //
// src/list/vue/List.vue